import { OpinieSliderComponent } from './opinie-slider/opinie-slider.component';
import { PageWithVideoComponent } from './page-with-video/page-with-video.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedUiModule } from '@enauka/shared/ui';
import { FormlyModule } from '@ngx-formly/core';
import { SharedApplicationModule } from '@enauka/shared/application';
import { FormsModule } from '@angular/forms';
import { LayoutComponent } from './layout/layout.component';
import { ColorFadeDirective } from './color-fade/color-fade.directive';
import { CarouselComponent } from './carousel/carousel.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@enauka/shared/ui/font-awesome';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedUiModule,
    FormsModule,
    FormlyModule,
    SharedApplicationModule,
    NgbCarouselModule,
    FontAwesomeModule,
  ],
  declarations: [
    LayoutComponent,
    PageWithVideoComponent,
    ColorFadeDirective,
    CarouselComponent,
    OpinieSliderComponent
  ],
  exports: [
    LayoutComponent,
    ColorFadeDirective,
    CarouselComponent,
    OpinieSliderComponent
  ]
})
export class StronaGlownaModule { }
